import React, { useState } from "react";
import { Button, Table, Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ApiPost, ApiPut, ApiDel } from "../../../service/ApiService";
import { MdDeleteForever, MdEdit, MdHelpOutline } from "react-icons/md";
import ProductModalForm from "./ProductModalForm";
import "./products.css"; 

const RequestProducts = ({ invoiceId, products, setProducts }) => {
  const [productError, setProductError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleAddProductModal = () => {
    setSelectedProduct(null);
    setShowModal(true);
  };

  const handleEditProductModal = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleDeleteProduct = (productId) => {
    ApiDel(
      `/api/smartbill/invoice/product/${productId}`,
      () => {
        setProducts((prevProducts) =>
          prevProducts.filter((p) => p.id !== productId)
        );
        setProductError(null);
      },
      (error) => setProductError("Eroare la ștergerea produsului.")
    );
  };

  const handleModalSave = (payload) => {
    if (payload.id) {
      // Existing product: update it.
      ApiPut(
        `/api/smartbill/invoice/product/${payload.id}`,
        payload,
        (response) => {
          setProducts((prevProducts) =>
            prevProducts.map((p) => (p.id === payload.id ? response : p))
          );
          setProductError(null);
        },
        (error) => setProductError("Eroare la actualizarea produsului.")
      );
    } else {
      // New product: add it.
      ApiPost(
        `/api/smartbill/invoice/${invoiceId}/product`,
        payload,
        (response) => {
          setProducts((prevProducts) => [...prevProducts, response]);
          setProductError(null);
        },
        (error) => setProductError("Eroare la adăugarea produsului.")
      );
    }
  };

  return (
    <div>
      {productError && <Alert variant="danger">{productError}</Alert>}

      <div className="mb-3">
        <Button variant="primary" onClick={handleAddProductModal}>
          Adaugă Produs
        </Button>
      </div>

      <Table striped bordered hover style={{ fontSize: "0.7rem"}} >
        <thead>
          <tr>
            <th>Denumire</th>
            <th>Cod</th>
            <th className="text-end">Cantitate</th>
            <th className="text-center">UM</th>
            <th className="text-end">Preț</th>
            <th className="text-center">Monedă</th>
            <th className="text-center">TVA</th>
            <th className="text-center">
              Serviciu
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={
                  <Tooltip id="tooltip-tva">
                    Indica dacă produsul este un serviciu prestat, sau bun finit
                  </Tooltip>
                }
              >
                <span style={{ cursor: "pointer" }}>
                  <MdHelpOutline
                    style={{ color: "#0d6efd", marginLeft: "5px" }}
                  />
                </span>
              </OverlayTrigger>
            </th>
            <th className="text-center">
              Adaugă
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="top"
                overlay={
                  <Tooltip id="tooltip-add">
                    Adaugă produsul în nomenclatorul SmartBill
                  </Tooltip>
                }
              >
                <span style={{ cursor: "pointer" }}>
                  <MdHelpOutline
                    style={{ color: "#0d6efd", marginLeft: "5px" }}
                  />
                </span>
              </OverlayTrigger>
            </th>
            <th>Depozit</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {products.map((prod) => (
            <tr key={prod.id}>
              <td>{prod.name}</td>
              <td className="mono">{prod.code}</td>
              <td className="text-end">{prod.quantity}</td>
              <td className="text-center">{prod.measuringUnitName}</td>
              <td className="text-end mono">{prod.price}</td>
              <td className="text-center">{prod.currency}</td>
              <td className="text-center">{prod.taxPercentage}%</td>
              <td className="text-center">{prod.service ? "da" : "-"}</td>
              <td className="text-center">{prod.saveToDb ? "da" : "-"}</td>
              <td className="text-center">{prod.warehouseName}</td>              
              <td className="actions">
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => handleEditProductModal(prod)}
                >
                  <MdEdit />
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  name="Delete"
                  onClick={() => handleDeleteProduct(prod.id)}
                >
                  <MdDeleteForever />           
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ProductModalForm
        show={showModal}
        onHide={() => setShowModal(false)}
        invoiceId={invoiceId}
        product={selectedProduct}
        onSave={handleModalSave}
      />
    </div>
  );
};

export default RequestProducts;